// extracted by mini-css-extract-plugin
module.exports = {"loginBox":"ForgotPassword_loginBox__MlD2B","background":"ForgotPassword_background__2nGD8","backgroundImage":"ForgotPassword_backgroundImage__JKYHW"};